var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        id: "svg" + _vm.assetID,
        width: _vm.w,
        height: _vm.h,
        viewBox: _vm.strViewbox,
        preserveAspectRatio: _vm.preserveAspectRatio,
        overflow: _vm.overflow,
        filter: _vm.filterID
      }
    },
    [
      _c("asset-loader", {
        attrs: { src: _vm.src, owner: _vm.assetID },
        on: { loaded: _vm.assetLoaded }
      }),
      _vm.filter
        ? _c(
            "defs",
            [
              _vm.filter
                ? _c(_vm.filter, {
                    tag: "component",
                    attrs: {
                      id: "filter" + _vm.assetID,
                      keyframe: _vm.keyframe
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _c(
        "g",
        { attrs: { id: "g" + _vm.assetID, transform: _vm.transform } },
        [_vm._t("default", null, { position: _vm.position, href: _vm.href })],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }